/**
 * Conference/Event Data Configuration
 * 
 * This file contains all event-specific content that can be updated yearly
 * without touching the layout code. Edit the values below to update the Events page.
 */

export const eventConfig = {
  // Basic Event Info
  event: {
    name: "ARGA Family Conference",
    year: 2027,
    tagline: "Favored to Finish",
    bibleVerse: "...being confident of this, that he who began a good work in you will carry it on to completion until the day of Christ Jesus.",
    bibleReference: "Philippians 1:6",
    theme: "Building Bridges, Strengthening Communities",
    description: `Join us for a powerful time of worship, teaching, and fellowship as believers from across the nation gather to grow in faith and community. This annual conference is a sacred opportunity to be refreshed in the presence of God, equipped through anointed teaching, and connected with fellow believers who share a passion for Christ.`,
    whoShouldAttend: [
      "Pastors and ministry leaders",
      "ARGA members and local assembly leaders",
      "Anyone passionate about following Jesus",
      "Worship leaders and ministry volunteers",
      "Those seeking spiritual renewal and growth"
    ],
    showCrest: false // Set to true to show the ARGA logo
  },

  // Dates
  dates: {
    start: "2027-04-08",
    end: "2027-04-12",
    displayText: "April 8-12, 2027",
    timezone: "Central Time (CT)"
  },

  // Venue Information
  venue: {
    name: "Crowne Plaza - St. Louis Airport",
    address: "11228 Lone Eagle Drive",
    city: "Bridgeton",
    state: "MO",
    zip: "63044",
    phone: "(314) 291-6700",
    mapUrl: "https://maps.google.com/?q=Crowne+Plaza+St.+Louis+Airport+11228+Lone+Eagle+Drive+Bridgeton+MO",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3114.5!2d-90.4109!3d38.7556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87df35c06e8d1e8b%3A0x8c8b8c8b8c8b8c8b!2sCrowne%20Plaza%20St.%20Louis%20Airport!5e0!3m2!1sen!2sus!4v1234567890"
  },

  // Hotel & Travel
  hotel: {
    name: "Crowne Plaza - St. Louis Airport",
    address: "11228 Lone Eagle Drive, Bridgeton, MO 63044",
    phone: "(314) 291-6700",
    bookingUrl: "https://www.ihg.com/crowneplaza/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99801505&icdv=99801505&qSlH=STLAP&qCiD=08&qCiMy=032027&qCoD=12&qCoMy=032027&qGrpCd=ARG&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=CP&qDest=11228%20Lone%20Eagle%20Drive,%20Bridgeton,%20MO,%20US&showApp=true&adjustMonth=false&srb_u=1&qRmFltr=",
    groupCode: null, // No code required - group rate is already applied in booking link
    groupRate: "$159/night",
    cutoffDate: null, // Book immediately - no cutoff specified
    depositRequired: false,
    checkIn: "3:00 PM",
    checkOut: "12:00 PM (Noon)",
    paymentNote: "Credit card required on file at booking. Card is only charged at check-in.",
    separateCostNote: "Hotel reservations are separate from conference registration.",
    amenities: [
      "Complimentary airport shuttle",
      "Free parking",
      "Fitness center",
      "On-site restaurant",
      "Indoor pool"
    ]
  },

  travel: {
    nearestAirport: "St. Louis Lambert International Airport (STL)",
    airportDistance: "Adjacent to hotel (complimentary shuttle available)",
    parking: "Free self-parking available for all guests",
    additionalNotes: "The hotel is conveniently located just minutes from downtown St. Louis and the Gateway Arch."
  },

  // Registration & Pricing
  registration: {
    deadline: "February 15, 2027",
    deadlineDate: "2027-02-15",
    totalPrice: 290,
    tiers: [
      {
        name: "Early Bird",
        price: 270,
        savings: 20,
        endDate: "2026-11-30",
        description: "Register by November 30, 2026 — Save $20!"
      },
      {
        name: "Standard",
        price: 290,
        endDate: "2027-02-15",
        description: "December 1, 2026 - February 15, 2027"
      }
    ],
    includes: [
      "All conference sessions and workshops",
      "Welcome reception & Meet and Greet",
      "Opening and closing services",
      "Conference materials",
      "Networking events",
      "Certificate of attendance"
    ],
    deposit: {
      amount: 50,
      nonRefundable: true,
      deadline: "Upon registration",
      terms: "This deposit covers processing fees and cannot be refunded."
    },
    balanceDeadline: "February 15, 2027",
    balanceNote: "Total balance must be paid in full by February 15, 2027.",
    incrementalPaymentNote: "Once your $50 registration deposit is paid, you may pay the remaining balance incrementally until the firm cutoff date of February 15, 2027."
  },

  // Payment Info
  payment: {
    checkPayable: "Anointed Remnant Global Assembly",
    mailingAddress: "502 Greystone Way #681223, Prattville, AL 36068",
    dropdownLabel: "Conference Registration - ARGA 2027",
    acceptedMethods: [
      { name: "PayPal", icon: "paypal" },
      { name: "Western Union", icon: "western-union" },
      { name: "Money Order", icon: "money-order" },
      { name: "MoneyGram", icon: "moneygram" },
      { name: "Check by Mail", icon: "check" }
    ]
  },

  // Conference Schedule
  schedule: [
    {
      day: "Day 1",
      date: "Tuesday, April 8",
      sessions: [
        { time: "Throughout Day", title: "Arrival & Hotel Check-in", location: "Hotel Lobby", speaker: null, description: "Check-in begins at 3:00 PM" },
        { time: "4:30 PM", title: "Meet and Greet", location: "TBA", speaker: null, description: "Welcome and fellowship" },
        { time: "Evening", title: "Opening Service", location: "TBA", speaker: "TBA", description: null }
      ]
    },
    {
      day: "Day 2",
      date: "Wednesday, April 9",
      sessions: [
        { time: "TBA", title: "Morning Session", location: "TBA", speaker: "TBA", description: "Full schedule coming soon" },
        { time: "TBA", title: "Afternoon Session", location: "TBA", speaker: "TBA", description: null },
        { time: "TBA", title: "Evening Session", location: "TBA", speaker: "TBA", description: null }
      ]
    },
    {
      day: "Day 3",
      date: "Thursday, April 10",
      sessions: [
        { time: "TBA", title: "Morning Session", location: "TBA", speaker: "TBA", description: "Full schedule coming soon" },
        { time: "TBA", title: "Afternoon Session", location: "TBA", speaker: "TBA", description: null },
        { time: "TBA", title: "Evening Session", location: "TBA", speaker: "TBA", description: null }
      ]
    },
    {
      day: "Day 4",
      date: "Friday, April 11",
      sessions: [
        { time: "TBA", title: "Morning Session", location: "TBA", speaker: "TBA", description: "Full schedule coming soon" },
        { time: "TBA", title: "Afternoon Session", location: "TBA", speaker: "TBA", description: null },
        { time: "TBA", title: "Evening Session", location: "TBA", speaker: "TBA", description: null }
      ]
    },
    {
      day: "Day 5",
      date: "Saturday, April 12",
      sessions: [
        { time: "By 10:00 AM", title: "Departure", location: "Hotel", speaker: null, description: "Safe travels! Hotel checkout is by Noon." }
      ]
    }
  ],

  // FAQ
  faq: [
    {
      question: "What is the refund policy?",
      answer: "The $50 registration deposit is non-refundable due to processing fees. Please ensure you can attend before registering."
    },
    {
      question: "When is the payment deadline?",
      answer: "The full conference balance of $290 (or $270 for Early Bird) must be paid by February 15, 2027. No refunds will be made after this date. Once your $50 registration deposit is paid, you may pay the remaining balance incrementally until the firm cutoff date."
    },
    {
      question: "What is included in the conference fee?",
      answer: "Your conference fee ($270 Early Bird / $290 Regular) includes all conference sessions, welcome reception, opening and closing services, conference materials, and meals at the hotel. Dining outside of the hotel is at the guest's expense. The initial $50 deposit confirms your seat and will be deducted from your total conference fee. Hotel accommodations are a separate cost and must be booked using the link provided on this page to receive the discounted group rate."
    },
    {
      question: "Is there a dress code?",
      answer: "Business casual attire is appropriate for daytime sessions. Please check back for specific guidance on evening services."
    },
    {
      question: "Is the hotel cost included in registration?",
      answer: "No, hotel reservations are separate from conference registration. You must book your hotel room directly with the Crowne Plaza at the group rate of $159/night."
    },
    {
      question: "Do I need a code to book the hotel?",
      answer: "No code is required. The group rate is automatically applied when you use the booking link provided on this page."
    },
    {
      question: "Is there a hotel deposit required?",
      answer: "No deposit is required for the hotel. A credit card is required on file when booking, but it will only be charged at check-in."
    },
    {
      question: "What are the hotel check-in and check-out times?",
      answer: "Check-in is at 3:00 PM and check-out is by 12:00 PM (Noon)."
    },
    {
      question: "Is there parking available?",
      answer: "Yes, complimentary self-parking is available at the hotel for all conference attendees."
    },
    {
      question: "What payment methods are accepted?",
      answer: "We accept PayPal, Western Union, MoneyGram, money orders, and checks by mail. Checks and money orders should be made payable to 'Anointed Remnant Global Assemblies' and mailed to the address provided."
    },
    {
      question: "Can I pay by check?",
      answer: "Yes, checks should be made payable to 'Anointed Remnant Global Assemblies' and mailed to: 502 Greystone Way #681223, Prattville, AL 36068. Please include your name and 'ARGA Conference 2027' on the memo line."
    }
  ],

  // Contact
  contact: {
    emails: ["beltonfamily@att.net", "katinalws73@gmail.com"],
    phone: "(314) 555-0123",
    subject: "ARGA Conference 2027 Inquiry"
  },

  // Images
  images: {
    hero: "https://images.unsplash.com/photo-1675906798393-89cbae461520?auto=format&fit=crop&w=2000&q=80",
    crest: null // Set to image URL to show a logo/crest above "Save the Date"
  }
};

export default eventConfig;
